const MONTHS = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
];

const DATE_ONLY = /^(\d{4})-(\d{2})-(\d{2})$/;

export const formatEventDate = (isoString) => {
    if (typeof isoString !== 'string' || isoString.length === 0) {
        return '';
    }
    // For pure date-only strings (no time component) treat as a local calendar date so
    // visitors don't see the day shift across the UTC/local boundary.
    const dateOnlyMatch = isoString.match(DATE_ONLY);
    if (dateOnlyMatch) {
        const [, year, month, day] = dateOnlyMatch;
        return `${MONTHS[Number(month) - 1]} ${Number(day)}, ${year}`;
    }
    const date = new Date(isoString);
    if (Number.isNaN(date.getTime())) {
        return '';
    }
    return `${MONTHS[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`;
};

export default formatEventDate;
